import type { Dict } from '../i18n'

type HintName = Extract<keyof Dict, `hintName${string}`>
type HintText = Exclude<Extract<keyof Dict, `hint${string}`>, HintName>

export interface HelpEntry {
  /** The question the explanation mark carries as its accessible name. */
  name: HintName
  /** The standalone explanation. */
  text: HintText
}

/**
 * The help panel's entries (GRO-66): keys only. The texts stay where GRO-63 put them in
 * `i18n.ts`, so the help panel and the table's explanation marks read the same strings and
 * there is no second copy to drift. The order follows the table's columns, then the totals
 * row. `helpEntries.test.ts` fails when a hint is added without an entry here.
 */
export const HELP_ENTRIES: readonly HelpEntry[] = [
  { name: 'hintNameShape', text: 'hintShape' },
  { name: 'hintNameShare', text: 'hintShare' },
  { name: 'hintNameFun', text: 'hintFun' },
  { name: 'hintNamePurch', text: 'hintPurch' },
  { name: 'hintNameRoas', text: 'hintRoas' },
  { name: 'hintNameAdj', text: 'hintAdj' },
  { name: 'hintNameAov', text: 'hintAov' },
  { name: 'hintNameBand', text: 'hintBand' },
  { name: 'hintNameRankable', text: 'hintRankable' },
]
